const beneficiaryRoutes = (prop) => [
    {
        path: 'beneficiary-list',
        name: prop + '.beneficiary_list',
        meta: { auth: true },
        component: () => import('../pages/beneficiary-management/List.vue')
    },
    {
        path: 'payment-dashboard',
        name: prop + '.payment_dashboard',
        meta: { auth: true },
        component: () => import('../pages/dashboard/payment-dashboard.vue')
    },
    {
        path: 'online-payment',
        name: prop + '.online_payment',
        meta: { auth: true },
        component: () => import('../pages/online-payment/List.vue')
    },
    {
        path: 'special-grant-eft',
        name: prop + '.special_grant_eft',
        meta: { auth: true },
        component: () => import('../pages/special-grant-eft/List.vue')
    },
    {
        path: 'private-orphanage-eft',
        name: prop + '.private_orphanage_eft',
        meta: { auth: true },
        component: () => import('../pages/private-orphanage-eft/List.vue')
    },
    {
        path: 'rg-voluntary-eft',
        name: prop + '.rg_voluntary_eft',
        meta: { auth: true },
        component: () => import('../pages/rg-voluntary-eft/List.vue')
    },
    {
        path: 'national-level-grant-eft',
        name: prop + '.national_level_grant_eft',
        meta: { auth: true },
        component: () => import('../pages/national-level-grant-eft/List.vue')
    },
    {
        path: 'coordination-council-eft',
        name: prop + '.coordination_council_eft',
        meta: { auth: true },
        component: () => import('../pages/coordination-council-eft/List.vue')
    },
    {
        path: 'correction-of-offender-eft',
        name: prop + '.correction_of_offender_eft',
        meta: { auth: true },
        component: () => import('../pages/correction-of-offender-eft/List.vue')
    },
    {
        path: 'patient-welfare-assoc-eft',
        name: prop + '.patient_welfare_assoc_eft',
        meta: { auth: true },
        component: () => import('../pages/patient-welfare-assoc/List.vue')
    },
    {
        path: 'medical-treatment-eft',
        name: prop + '.medical_treatment_eft',
        meta: { auth: true },
        component: () => import('../pages/medical-treatment-eft/List.vue')
    },
    {
        path: 'medical-treatment-eft-quarter/:id?',
        name: prop + '.medical_treatment_eft_quarter',
        meta: { auth: true },
        component: () => import('../pages/medical-treatment-eft/quarter.vue')
    },
    {
        path: 'medical-treatment-ministry-eft',
        name: prop + '.medical_treatment_ministry_eft',
        meta: { auth: true },
        component: () => import('../pages/medical-treatment-eft/List.vue')
    },
    {
        path: 'medical-treatment-ministry-eft-quarter/:id?',
        name: prop + '.medical_treatment_ministry_eft_quarter',
        meta: { auth: true },
        component: () => import('../pages/medical-treatment-eft/quarter.vue')
    }
]
const routes = [{
    path: '/grant-allowance-service/payment-mangement',
    name: 'grant_allowance_service.payment_management',
    component: () => import('@/layouts/GrantAllowanceLayout.vue'),
    meta: { auth: true },
    children: beneficiaryRoutes('grant_allowance_service.payment_management')
}]
export default routes
